import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { getLatestTaskList } from "../Firebase/getLatestTaskListAction";
import * as idb from '../../../functions/databaseService/indexedDB';
import signOut from "../../../functions/userIdentity/signOut";

// Action Types
export const CHANGE_SIBLING_POSITION_SUCCESS = "CHANGE_SIBLING_POSITION_SUCCESS";
export const CHANGE_SIBLING_POSITION_ERROR = "CHANGE_SIBLING_POSITION_ERROR";

// Thunk Action Creator
export const changeSiblingPosition = createAsyncThunk(
    "api/Task/changeSiblingPosition",
    async (json, { dispatch }) => {
        try {
            const online = navigator.onLine;

            if (online) {
                const response = await axios.put(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/changeSiblingPosition/${json.id}`,
                    { newPosition: json.newPosition },
                    { headers: { "Content-Type": "application/json" } }
                );

                if (response.status === 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        idb.storeTaskList(response.data.tasks || response.data);
                    }
                }
                else {
                    throw new Error("Error occured changing sibling position");
                }

                // Get data from IndexedDB
                const taskListData = await idb.getTasks();

                dispatch({
                    type: CHANGE_SIBLING_POSITION_SUCCESS,
                    payload: response.data,
                });

            
            } else {
                // Get data from IndexedDB
                const taskListData = await idb.getTasks();

                if (taskListData) {
                    // Dispatch IndexedDB data instead of Axios result
                    dispatch({
                        type: CHANGE_SIBLING_POSITION_SUCCESS,
                        payload: taskListData,
                    });
                } else {
                    console.log("No tasks found in IndexedDB");
                }
            }
        } catch (error) {
             
            dispatch({
                type: CHANGE_SIBLING_POSITION_ERROR,
                payload: error.message || "An error occurred",
            });
            await signOut();
            //.then(response => {
            //    dispatch({
            //        type: CHANGE_SIBLING_POSITION_SUCCESS,
            //        payload: response.data,
            //    });
            //    dispatch(getLatestTaskList());
            //})
            //.catch(error => {
            //    dispatch({ type: CHANGE_SIBLING_POSITION_ERROR, payload: error });
            //});
        }
    }
);

      
 